<template>
  <div class="lib__panel">
    <div class="lib__panel__main">
      <div class="lib__text-small lib__text-gray-500">{{ $t('complaint.resume.complaintAddress') }}</div>
      <template v-if="!address.isMapLocation">{{ address.streetSubCity.name }} {{ address.houseNumber }} {{ address.houseBox !== null ? address.houseBox : '' }}</template>
      <template v-else>{{ address.mapLocation.lat }} {{ address.mapLocation.lng }}</template>
      - {{ address.subCity.cityName }} {{ address.subCity.zipCode }}
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AddressPoint } from '@/models';

@Component
export default class ResumeInfoItem extends Vue {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly address!: AddressPoint;
  //#endregion
}
</script>